import { Component, OnInit, ViewChild, ViewChildren } from '@angular/core';
import * as moment from 'moment';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { NgxDateRangePickerComponent } from '../../../widget-library/widgets/ngx-date-range-picker/ngx-date-range-picker.component';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import * as $ from 'jquery';
import { ActivatedRoute } from '@angular/router';
@Component({
	selector: 'app-ngx-date-range-picker-inline',
	templateUrl: './ngx-date-range-picker-inline.component.html',
	styleUrls: ['./ngx-date-range-picker-inline.component.css']
})
export class NgxDateRangePickerInlineComponent extends NgxDateRangePickerComponent implements OnInit {
	public startDatelable: any;
	public endDatelable: any;
	public dateFromInput: boolean;
	public tooltiptitle: string = 'test msg';
	public tooltipId: any;
	public startDateMsg: string;
	public endDateMsg: string;
	public startTooltipContainer: any;
	public endTooltipContainer: any;
	public startTooltiptext: any;
	public endTooltiptext: any;
	public updatecalander: boolean;
	public hoverStartdt: any;
	public hoverEnddt: any;
	public pickedStartdt: any;
	public pickedEnddt: any;
	public enableStartmsg: boolean;
	public enableEndmsg: boolean;
	public side: any;
	public tempStartdt: boolean;
	public tempEnddt: boolean;
	public scrollableElement: any;
	public startdtmouseover: any;
	public enddtmouseover: any;
	public localConfig: any = {
		weekLabel: 'WWW',
		clearLabel: 'Clear', // detault is 'Clear'
		customRangeLabel: 'Custom range',
		daysOfWeek: moment.weekdaysShort(),
		monthNames: moment.months(),
		firstDay: 1 // first day is monday
	};

	constructor(
		protected activatedRoute: ActivatedRoute,
		protected analyticsDataModel: AnalyticsDataModel,
		protected analyticsService: AnalyticsService
	) {
		super(activatedRoute, analyticsDataModel, analyticsService);
		this.scrollableElement = document.getElementById('left-section');
		this.scrollableElement.addEventListener('scroll', this.scrollEvent, true);
		this.hoverStartdt = EmitterService.get(EVENT_EMITTERS.HOVER_START_DATE).subscribe((resp: any) => {
			if (resp) {
				this.hoverStartdt = resp.date;
				this.side = resp.label;
				this.dateFromInput = true;
				this.validateDate();
			}
		});
		this.hoverEnddt = EmitterService.get(EVENT_EMITTERS.HOVER_END_DATE).subscribe((resp: any) => {
			if (resp) {
				this.hoverEnddt = resp.date;
				this.side = resp.label;
				this.dateFromInput = true;
				if (resp.date === 'Invalid date') {
					this.hoverEnddt = moment(this.daterange.end).format('MM/DD/YYYY');
				}
				this.validateDate();
			}
		});
		this.pickedStartdt = EmitterService.get(EVENT_EMITTERS.PICK_START_DATE).subscribe((resp: any) => {
			if (resp) {
				this.side = resp.label;
				this.pickedStartdt = resp.date;
				this.startdtmouseover.removeEventListener('mouseover', this.enableStartdtEvent, true);
				this.startdtmouseover.removeEventListener('mouseleave', this.disableStartdtEvent, true);
				this.startTooltipContainer.classList.remove('active');
				this.startTooltiptext.classList.remove('active');
				this.updatecalander = true;
				this.dateFromInput = false;
			}
		});
		this.pickedEnddt = EmitterService.get(EVENT_EMITTERS.PICK_END_DATE).subscribe((resp: any) => {
			if (resp) {
				this.side = resp.label;
				this.pickedEnddt = resp.date;
				this.endTooltipContainer.classList.remove('active');
				this.endTooltiptext.classList.remove('active');
				this.enddtmouseover.removeEventListener('mouseover', this.enableEndtdtEvent, true);
				this.enddtmouseover.removeEventListener('mouseleave', this.disableEnddtEvent, true);
				this.updatecalander = true;
				this.dateFromInput = false;
			}
		});
	}
	ngOnDestroy() {
		this.scrollableElement.removeEventListener('scroll', this.scrollEvent, true);
	}

	scrollEvent = (event: any): void => {
		$('#startdtMessage').css({
			left: '210px',
			top: $('#startdtHelper').offset().top
		});
		$('#enddtMessage').css({
			left: '423px',
			top: $('#enddtHelper').offset().top
		});
	};
	ngAfterViewInit(): void {
		this.startTooltipContainer = document.querySelector('.startTooltipContainer');
		this.endTooltipContainer = document.querySelector('.endTooltipContainer');
		this.startTooltiptext = document.getElementById('startdtMessage');
		this.endTooltiptext = document.getElementById('enddtMessage');
		this.startdtmouseover = document.getElementById('startdtHelper');
		this.enddtmouseover = document.getElementById('enddtHelper');
	}
	changeDate(label) {
		this.dateFromInput = true;
	}
	validateDate() {
		this.updatecalander = true;
		this.enableStartmsg = false;
		this.enableEndmsg = false;
		this.startTooltipContainer.classList.remove('active');
		this.endTooltipContainer.classList.remove('active');
		this.endTooltiptext.classList.remove('active');
		this.startTooltiptext.classList.remove('active');
		this.startdtmouseover.addEventListener('mouseover', this.enableStartdtEvent, true);
		this.startdtmouseover.addEventListener('mouseleave', this.disableStartdtEvent, true);
		this.enddtmouseover.addEventListener('mouseover', this.enableEndtdtEvent, true);
		this.enddtmouseover.addEventListener('mouseleave', this.disableEnddtEvent, true);
		if (this.hoverStartdt.trim().length < 1) {
			this.startTooltipContainer.classList.toggle('active');
			this.startTooltiptext.classList.toggle('active');
			this.startDateMsg = 'Please enter a start date';
			this.updatecalander = false;
			this.enableStartmsg = true;
		} else if (/^(\d{1,2})[-\/](\d{1,2})[-\/](\d{4})$/.exec(this.hoverStartdt) === null) {
			this.startTooltipContainer.classList.toggle('active');
			this.startTooltiptext.classList.toggle('active');
			this.startDateMsg = 'Please enter a date with the following format: MM/DD/YYYY';
			this.updatecalander = false;
			this.enableStartmsg = true;
		} else if (moment(this.hoverStartdt).format('MM/DD/YYYY') === 'Invalid date') {
			this.startTooltipContainer.classList.toggle('active');
			this.startTooltiptext.classList.toggle('active');
			this.startDateMsg = 'Please enter a date with the following format: MM/DD/YYYY';
			this.updatecalander = false;
			this.enableStartmsg = true;
		} else if (moment(this.hoverStartdt).isAfter(this.hoverEnddt)) {
			this.startTooltipContainer.classList.toggle('active');
			this.startTooltiptext.classList.toggle('active');
			this.startDateMsg = 'Start date must come before the end date';
			this.updatecalander = false;
			this.enableStartmsg = true;
		} else if (moment(this.hoverStartdt).isAfter(moment())) {
			this.startTooltipContainer.classList.toggle('active');
			this.startTooltiptext.classList.toggle('active');
			this.startDateMsg = 'Start date cannot be after the current date';
			this.updatecalander = false;
			this.enableStartmsg = true;
		} else if (moment(this.hoverStartdt).isBefore('01/01/1970')) {
			this.startTooltipContainer.classList.toggle('active');
			this.startTooltiptext.classList.toggle('active');
			this.startDateMsg = 'Start date cannot be before 01/01/1970';
			this.updatecalander = false;
			this.enableStartmsg = true;
		}
		$('#startdtMessage').css({
			left: '210px',
			top: $('#startdtHelper').offset().top
		});
		if (!this.updatecalander) {
			$('#startdtMessage').html(this.startDateMsg);
		}
		if (!this.enableStartmsg) {
			$('#startdtMessage').css('display', 'none');
			this.startdtmouseover.removeEventListener('mouseover', this.enableStartdtEvent, true);
			this.startdtmouseover.removeEventListener('mouseleave', this.disableStartdtEvent, true);
		}
		if (this.hoverEnddt.trim().length < 1) {
			this.endTooltipContainer.classList.toggle('active');
			this.endTooltiptext.classList.toggle('active');
			this.endDateMsg = 'Please enter an end date';
			this.updatecalander = false;
			this.enableEndmsg = true;
		} else if (/^(\d{1,2})[-\/](\d{1,2})[-\/](\d{4})$/.exec(this.hoverEnddt) === null) {
			this.endTooltipContainer.classList.toggle('active');
			this.endTooltiptext.classList.toggle('active');
			this.endDateMsg = 'Please enter a date with the following format: MM/DD/YYYY';
			this.updatecalander = false;
			this.enableEndmsg = true;
		} else if (moment(this.hoverEnddt).format('MM/DD/YYYY') === 'Invalid date') {
			this.endTooltipContainer.classList.toggle('active');
			this.endTooltiptext.classList.toggle('active');
			this.endDateMsg = 'Please enter a date with the following format: MM/DD/YYYY';
			this.updatecalander = false;
			this.enableEndmsg = true;
		} else if (moment(this.hoverEnddt).isBefore(this.hoverStartdt)) {
			this.endTooltipContainer.classList.toggle('active');
			this.endTooltiptext.classList.toggle('active');
			this.endDateMsg = 'End date cannot be earlier than the start date';
			this.updatecalander = false;
			this.enableEndmsg = true;
		} else if (moment(this.hoverEnddt).isAfter(moment())) {
			this.endTooltipContainer.classList.toggle('active');
			this.endTooltiptext.classList.toggle('active');
			this.endDateMsg = 'End date cannot be after the current date';
			this.updatecalander = false;
			this.enableEndmsg = true;
		}
		$('#enddtMessage').css({
			left: '423px',
			top: $('#enddtHelper').offset().top
		});
		if (!this.updatecalander) {
			$('#enddtMessage').html(this.endDateMsg);
		}
		if (!this.enableEndmsg) {
			$('#enddtMessage').css('display', 'none');
			this.enddtmouseover.removeEventListener('mouseover', this.enableEndtdtEvent, true);
			this.enddtmouseover.removeEventListener('mouseleave', this.disableEnddtEvent, true);
		}
	}
	ngOnInit(): void {
		this.startDatelable = moment(this.daterange.start).format('MM/DD/YYYY');
		this.endDatelable = moment(this.daterange.end).format('MM/DD/YYYY');
		this.hoverStartdt = moment(this.daterange.start).format('MM/DD/YYYY');
		this.hoverEnddt = moment(this.daterange.end).format('MM/DD/YYYY');
		this.dateFromInput = false;
		this.updatecalander = true;
		this.firstChange = false;
		super.ngOnInit();
	}
	public applyDate(e: any) {
		if (this.dateFromInput) {
			this.analyticsDataModel.userInteracted = true;
			let temp = {
				startDate: moment(this.hoverStartdt),
				endDate: moment(this.hoverEnddt)
			};
			if (this.updatecalander) {
				this.selected.startDate = moment(this.hoverStartdt);
				this.selected.endDate = moment(this.hoverEnddt);
				super.applyDate(temp);
			}
			this.dateFromInput = false;
		} else if (this.updatecalander) {
			this.analyticsDataModel.userInteracted = true;
			this.hoverStartdt = moment(e.startDate).format('MM/DD/YYYY');
			this.hoverEnddt = moment(e.endDate).format('MM/DD/YYYY');
			EmitterService.get(EVENT_EMITTERS.HOVER_START_DATE).emit({
				date: this.hoverStartdt
			});
			EmitterService.get(EVENT_EMITTERS.HOVER_END_DATE).emit({
				date: this.hoverEnddt
			});
			this.startdtmouseover.removeEventListener('mouseover', this.enableStartdtEvent, true);
			this.startdtmouseover.removeEventListener('mouseleave', this.disableStartdtEvent, true);
			this.enddtmouseover.removeEventListener('mouseover', this.enableEndtdtEvent, true);
			this.enddtmouseover.removeEventListener('mouseleave', this.disableEnddtEvent, true);
			super.applyDate(e);
		} else {
			this.firstChange = false;
			super.applyDate(e);
		}
	}
	enableStartdtEvent = (event: any): void => {
		$('#startdtMessage').css({ 'margin-left': '0px', display: 'block' });
	};
	disableStartdtEvent = (event: any): void => {
		$('#startdtMessage').css('display', 'none');
	};
	enableEndtdtEvent = (event: any): void => {
		$('#enddtMessage').css({ 'margin-left': '0px', display: 'block' });
	};
	disableEnddtEvent = (event: any): void => {
		$('#enddtMessage').css('display', 'none');
	};
}
